import React from "react";
import Chart from "react-apexcharts";

const SkillBar = ({ data }) => {
  const { master, competent, learning, novice } = data;

  const allEmpty = [master, competent, learning, novice].every(
    (val) => val === null || val === undefined || val === 0
  );

  if (allEmpty) {
    return <span>-</span>;
  }

  const chartData = [
    { name: "Master", data: [master ?? 0] },
    { name: "Competent", data: [competent ?? 0] },
    { name: "Learner", data: [learning ?? 0] },
    { name: "Novice", data: [novice ?? 0] },
  ];

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      sparkline: { enabled: true },
      toolbar: { show: false },
      animations: { enabled: false },
      parentHeightOffset: 0,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "100%",
        columnWidth: "100%",
        dataLabels: {
          position: "center",
        },
      },
    },
    tooltip: { enabled: false },
    dataLabels: {
      enabled: true,
      offsetY: 1, // vertically center
      style: {
        colors: ["#fff"],
        fontSize: "10px",
        fontWeight: 400,
      },
      formatter: (val) => (val > 0 ? `${val}%` : ""),
    },
    legend: { show: false },
    xaxis: {
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
      max: 100, // ensures full width for percentages
    },
    yaxis: { show: false },
    grid: { show: false, padding: { top: 0, bottom: 0, left: 0, right: 0 } },
    colors: ["#28A745", "#508FD6", "#EC930D", "#EAD51A"],
    stroke: { width: 0 },
  };

  return (
    <div style={{ width: "100%", height: "16px", padding: 0, margin: 0 }}>
      <Chart
        options={options}
        series={chartData}
        type="bar"
        height="100%"
        width="100%"
      />
    </div>
  );
};

export default SkillBar;
